import EditorialLayout from '../components/EditorialLayout'

export default function Terms() {
  return (
    <EditorialLayout
      title='Terms of Use | Guitar-Tuner.org'
      description='Terms governing access to and use of the Guitar-Tuner.org online tuner, reference sounds, guides, and related website content.'
      path='/terms'
      eyebrow='Legal'
      updated='August 10, 2026'
    >
      <h2>1. About these terms</h2>
      <p>
        These Terms of Use apply when you access Guitar-Tuner.org, use its
        browser-based tuner or reference sounds, or read its guides. The website
        is operated by ChordChord OÜ, Sepapaja 6, Tallinn 15551, Estonia. You can
        contact us at{' '}
        <a href='mailto:team@guitar-tuner.org'>team@guitar-tuner.org</a>.
      </p>
      <p>
        By using the website, you agree to these terms. If you do not agree,
        please stop using the website. Nothing in these terms limits rights that
        cannot legally be excluded, including mandatory consumer rights.
      </p>

      <h2>2. The service</h2>
      <p>
        Guitar-Tuner.org provides an online pitch-detection tuner, reference
        sounds, frequency information, and educational content. The service is
        provided for general musical and informational purposes. Results can be
        affected by microphone quality, background noise, instrument overtones,
        browser compatibility, and device settings.
      </p>
      <p>
        We may improve, modify, suspend, or discontinue parts of the website.
        We do not promise that every feature will always be available or free
        from interruptions or errors.
      </p>

      <h2>3. Microphone use</h2>
      <p>
        Automatic tuning requires permission to use your device microphone.
        Pitch analysis is performed locally in your browser, and
        Guitar-Tuner.org does not intend to record, upload, or store the audio
        used for tuning. You control microphone permission through your browser
        or device settings.
      </p>

      <h2>4. Acceptable use</h2>
      <p>You may use the website for lawful personal or educational purposes. You must not:</p>
      <ul>
        <li>interfere with the website, its security, or other visitors;</li>
        <li>attempt to gain unauthorised access to systems or data;</li>
        <li>use automated requests in a way that places an unreasonable load on the service;</li>
        <li>introduce malicious code or use the website for unlawful activity; or</li>
        <li>misrepresent an association with Guitar-Tuner.org or ChordChord OÜ.</li>
      </ul>

      <h2>5. Website content and intellectual property</h2>
      <p>
        Unless stated otherwise, the website design, text, graphics, audio,
        software, and other original content are owned by ChordChord OÜ or used
        with permission. You may view and use the website for its intended
        purpose. These terms do not transfer ownership or grant permission to
        republish, sell, or distribute substantial parts of the website.
      </p>

      <h2>6. Advertising and third-party services</h2>
      <p>
        The website may display advertising and link to third-party websites or
        services. Third parties are responsible for their own content, products,
        availability, and privacy practices. A link or advertisement does not
        necessarily mean that we endorse the third party.
      </p>

      <h2>7. Disclaimer and liability</h2>
      <p>
        We take reasonable care when preparing the tuner and educational
        content, but provide the website on an “as available” basis. To the
        maximum extent permitted by law, we do not guarantee uninterrupted
        availability or that every pitch reading, frequency, or instruction
        will be suitable for every instrument or situation.
      </p>
      <p>
        ChordChord OÜ is not liable for indirect or consequential loss arising
        from use of, or inability to use, the website where such liability may
        lawfully be limited. We do not exclude liability that cannot be excluded
        under applicable law.
      </p>

      <h2>8. Privacy</h2>
      <p>
        Our <a href='/privacy-policy'>Privacy Policy</a> explains how the website
        handles microphone access, technical information, analytics,
        advertising technologies, and privacy choices.
      </p>

      <h2>9. Changes to these terms</h2>
      <p>
        We may update these terms when the website, our business, or applicable
        requirements change. The updated version will be published on this page
        with a revised review date. Continued use after an update means the new
        terms apply from that point forward.
      </p>

      <h2>10. Governing law</h2>
      <p>
        These terms are governed by Estonian law, without depriving consumers
        of mandatory protections available under the law of their country of
        residence. Courts and dispute-resolution bodies with jurisdiction under
        applicable law may hear disputes concerning these terms.
      </p>
    </EditorialLayout>
  )
}
